import React from "react";
import { Grid, FormControlLabel, Checkbox } from "@mui/material";

export default function CostFluctuationField({ disabled, value, onChange }) {
  const handleChange = (e) => {
    onChange({ fluctuation: e.target.checked });
  };

  return (
    <Grid
      item
      xs={12}
      sm={5}
      sx={{
        fontWeight: "bold",
        paddingLeft: { sm: "20px" },
        paddingBottom: { sm: "20px" },
      }}
    >
      <FormControlLabel
        disabled={disabled}
        control={<Checkbox checked={!!value} onChange={handleChange} />}
        label="金額帯がご希望に近い要員も表示"
      />
    </Grid>
  );
}